module.exports = __webpack_public_path__ + "static/media/Network_Workspace_School_Import_Template.8f69180a.xlsx";